import { rgb } from '../helpers';
import {
    BLACK,
    YELLOW,
    DARK_YELLOW,
    WHITE,
    DARKEST_BLUE,
    DARK_BLUE,
    LIGHT_BLUE,
    MIDDLE_BLUE,
    DARKEST_YELLOW
} from '../theme/color';

export const overrides = {
    MuiListItem: {
        root: {
            '&.MuiListItem-root.NeptuneDropdown-placeholder': {
                color: `rgba(${rgb(DARK_BLUE)}, .24)`
            }
        }
    },
    MuiButton: {
        root: {
            '& .MuiCircularProgress-colorSecondary': {
                color: WHITE
            }
        },
        containedPrimary: {
            color: BLACK,
            backgroundColor: YELLOW,

            '&:hover, &:focus': {
                backgroundColor: DARK_YELLOW
            },

            '&:active': {
                backgroundColor: DARKEST_YELLOW
            }
        },

        containedSecondary: {
            backgroundColor: DARK_BLUE,
            color: WHITE,

            '&:hover, &:focus': {
                backgroundColor: LIGHT_BLUE
            },

            '&:active': {
                backgroundColor: DARKEST_BLUE
            }
        },

        textPrimary: {
            '&:hover, &:focus, &:active': {
                color: LIGHT_BLUE
            }
        },

        outlinedSecondary: {
            borderColor: `rgba(${rgb(DARK_BLUE)}, .68)`,
            color: DARK_BLUE,

            '&:hover, &:focus, &:active': {
                borderColor: DARK_BLUE
            },

            '&:hover, &:focus': {
                backgroundColor: `rgba(${rgb(MIDDLE_BLUE)}, .04)`
            },

            '&:active': {
                backgroundColor: `rgba(${rgb(MIDDLE_BLUE)}, .1)`
            }
        }
    }
};
